import React from 'react';
import { Field, TextOutput } from '../../../../Core';
import { ListFieldSection } from '../../../../Layout';
import { withInjectedProps } from '../../../../Core/InjectedPropsContext';
import { IWorksheetComponent, WorksheetsResultsMessagesSection } from '../../../Core';
import { MddChartSection } from '../../Shared';
import { useSelector } from 'react-redux';

const contextCaptions = [{ path: `data.TestPortions`, caption: 'Test Portions' }];

let AsResultsSection: React.FC<IWorksheetComponent> = ({ createWorksheetSelector }) => {
  const materialNotSuitableDueToOversize =
    useSelector(createWorksheetSelector!('Preparation.ScreeningASTM.MaterialNotSuitableDueToOversize')) ?? false;
  return (
    <>
      <MddChartSection visible={!materialNotSuitableDueToOversize} />
      <WorksheetsResultsMessagesSection contextCaptions={contextCaptions} />
      <ListFieldSection heading="Laboratory Results">
        <Field input={<TextOutput />} name="Results.MaximumDryDensity" emph />
        <Field input={<TextOutput />} name="Results.OptimumMoistureContent" emph />
      </ListFieldSection>
    </>
  );
};

AsResultsSection = withInjectedProps(AsResultsSection);

export { AsResultsSection };
export default AsResultsSection;
